import i18n from '../../../plugins/i18n'

export const templateOfDocumentBlock = `
    <div class="row content-block">
        <div class="col-10 column px-5 ma-2 rounded-xxl elevation-3 mx-auto document">
            <p class="d-inline-block custom-file-doc-position">
                <span style="color: #2979FF" class="mdi mdi-48px mdi-file-document-outline">&nbsp;</span>
            </p>
            <p class="d-inline-block custom-file-doc-position custom-file-doc-title mt-4">
                <span style="color: #263238">` + i18n.t('defaultDocumentTitle') + `</span><br />   
                <span style="color: #7C8386">0 MB</span>            
            </p>
        </div>
    </div>
`